import React from "react";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import PageHero from "@/components/site/PageHero";
import BottomCTA from "@/components/site/BottomCTA";
import useReveal from "@/hooks/useReveal";
import { COMPOSITION } from "@/data/investments";

export default function PortfolioComposition() {
  useReveal();
  return (
    <div className="min-h-screen bg-white text-unik-ink">
      <SiteNav />

      <PageHero
        eyebrow="Investment / Portfolio Composition"
        title="Three pillars of"
        accent={<><br/>long-term capital.</>}
        sub="Foundational real assets, partnerships and asset management, and the Chitta healthspan ecosystem — the three pillars on which the portfolio compounds."
        bgImage="/assets/7ti2178f_Berriver.jpg"
      />

      <section className="relative bg-white py-28 lg:py-40">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
          <div data-reveal className="max-w-3xl mb-16 lg:mb-20">
            <div className="eyebrow text-[#14355a]">Portfolio Composition</div>
            <h2
              style={{ fontSize: "clamp(2.25rem, 5vw, 4.5rem)", fontWeight: 500, lineHeight: "1.05" }}
              className="mt-6 font-display text-[#14355a] tracking-tight"
            >
              Three pillars of<br/>long-term capital.
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
            {COMPOSITION.map((c, i) => (
              <div
                key={c.n}
                data-reveal
                style={{ "--reveal-delay": `${i * 130}ms` }}
                className="relative bg-white border border-[#14355a]/10"
              >
                <div className="relative aspect-[5/3] overflow-hidden">
                  <img src={c.img} alt={c.t} className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-tr from-[#0e2540]/40 via-transparent to-transparent" />
                  <div
                    className="absolute bottom-5 left-7 font-display text-white tracking-[0.18em]"
                    style={{ fontSize: "clamp(1.75rem, 2.4vw, 2.5rem)", fontWeight: 500, lineHeight: 1 }}
                  >
                    {c.n}
                  </div>
                </div>
                <div className="p-8 lg:p-10">
                  <h3
                    style={{ fontSize: "clamp(1.375rem, 1.75vw, 1.625rem)", fontWeight: 500 }}
                    className="font-display text-[#14355a] tracking-tight leading-tight"
                  >
                    {c.t}
                  </h3>
                  <p className="mt-5 text-[15px] lg:text-[16px] leading-[1.85] text-unik-ink/75">{c.b}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <BottomCTA
        eyebrow="Continue Reading"
        title="See our"
        accent="investment evolution."
        body="From foundation to ecosystem maturity — the strategic phases that shape long-term value creation."
        primary={{ label: "Investment Evolution", to: "/investments/evolution" }}
        secondary={{ label: "Investment Approach", to: "/investments/approach" }}
      />

      <SiteFooter />
    </div>
  );
}
